"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoseCodesForAtom = getHoseCodesForAtom;
const getHoseCodesForAtoms_js_1 = require("./getHoseCodesForAtoms.js");
/**
 * Returns the hose code for a specific atom number
 * @param {import('openchemlib').Molecule} originalMolecule
 * @param {number} rootAtom
 * @param {object} [options={}]
 * @param {boolean} [options.isTagged] - Specify is the atom is already tagged
 * @param {number} [options.minSphereSize=0] - Smallest hose code sphere
 * @param {number} [options.maxSphereSize=4] - Largest hose code sphere
 * @param {number} [options.kind=FULL_HOSE_CODE] - Kind of hose code, default usual sphere
 */
function getHoseCodesForAtom(originalMolecule, rootAtom, options = {}) {
    return (0, getHoseCodesForAtoms_js_1.getHoseCodesForAtoms)(originalMolecule, [rootAtom], options);
}
//# sourceMappingURL=getHoseCodesForAtom.js.map